module.exports = __webpack_public_path__ + "static/media/6.e4525246.jpg";